module.exports = "/assets/dist/images/how-it-works-transmission.svg?b4b4a9d5fb88b34d27086e1e4034e647";